import React from 'react';
import { TrendingUp, DollarSign, Info } from 'lucide-react';

/**
 * Компонент секции маржи прибыли для калькулятора 3D-печати
 */
const ProfitMarginSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-100 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <TrendingUp className="w-5 h-5 mr-2 text-green-500" />
        Прибыль и валюта
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Включение прибыли */}
        <div>
          <div className="mb-2">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="includeProfit"
                checked={formData.includeProfit}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Включить маржу прибыли
              </span>
            </label>
          </div>
          
          {formData.includeProfit && (
            <div className="pl-6 border-l-2 border-green-200 dark:border-green-700 mt-3">
              <label htmlFor="profitMargin" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
                <DollarSign className="w-4 h-4 mr-1 text-green-500" />
                Маржа прибыли (%)
              </label>
              <input
                type="text"
                id="profitMargin"
                name="profitMargin"
                value={formData.profitMargin}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.profitMargin ? 'input-error' : ''}`}
                placeholder="Введите процент"
              />
              {errors.profitMargin && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.profitMargin}
                </p>
              )}
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Типичная маржа для 3D-печати составляет 20-50%
              </p>
            </div>
          )}
        </div>

        {/* Выбор валюты */}
        <div>
          <label htmlFor="currency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Валюта расчета
          </label>
          <select
            id="currency"
            name="currency"
            value={formData.currency}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="RUB">₽ (Рубль)</option>
            <option value="USD">$ (Доллар США)</option>
            <option value="EUR">€ (Евро)</option>
            <option value="CNY">¥ (Юань)</option>
          </select>
        </div>
      </div>
      
      <div className="mt-4 bg-green-100/50 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <Info className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Как правильно выбрать маржу прибыли
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              При выборе маржи учитывайте уникальность вашего предложения, конкуренцию и рыночные цены. Для стандартных изделий рекомендуется 20-30%, для сложных, уникальных или срочных заказов — до 50% и выше. При печати в больших объемах можно снижать маржу для повышения конкурентоспособности.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitMarginSection;